import { render, staticRenderFns } from "./indexLy.vue?vue&type=template&id=3cf84fea&scoped=true"
import script from "./indexLy.vue?vue&type=script&lang=js"
export * from "./indexLy.vue?vue&type=script&lang=js"
import style0 from "./indexLy.vue?vue&type=style&index=0&id=3cf84fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf84fea",
  null
  
)

export default component.exports